import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { store } from "./store";
import ChitalishtePage from "../src/pages/ChitalishtePage.jsx";
import KartaPage from "./pages/KartaPage.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import MetodologyPage from "./pages/MetodologyPage.jsx";
import FeedbackPage from "./pages/FeedbackPage.jsx";
import FaqPage from "./pages/FaqPage.jsx";
import ScrollToTop from "./components/layout/ScrollToTop.jsx";
import AdminLoginPage from "./pages/AdminLoginPage.jsx";
import AdminPanel from "./components/admin/AdminPanel.jsx";
import ProtectedRoute from "./routes/ProtectedRoute.jsx";
import { theme } from "./theme";
import "./App.css";
import GoogleAnalytics from "./components/GoogleAnalytics.jsx";

function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline /> {/* Важно за Material UI темата */}
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <GoogleAnalytics />
            <ScrollToTop />
            <Routes>
              {/* Публични маршрути */}
              <Route path="/" element={<KartaPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/methodology" element={<MetodologyPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="/community-center/*" element={<ChitalishtePage />} />

              {/* Административни маршрути */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </ThemeProvider>
      </HelmetProvider>
    </Provider>
  );
}

export default App;
